<template>
  <form class="rent-form">
    <div class="rent-form__part">
      <div class="rent-form__fields">
        <rent-form-location-field location="start" v-bind:class="{disable: isLoading.locationsStart}" :openEnd="endLocationOpened" @setStartLocation="endLocationOpened = true" />
        <rent-form-location-field location="end" v-bind:class="{disable: isLoading.locationsEnd}" :openEnd="endLocationOpened" @close="endLocationOpened = false" />
      </div>
    </div>
    <div class="rent-form__part rent-form__part--small">
      <div class="rent-form__fields">
        <div class="rent-form__field-box">
          <label class="rent-form__field-label">Дата начала</label>
          <div class="rent-form__field-group">
            <div class="rent-form__datetime">
              <date-picker v-model="dateStartField" @change="changeStartDateTime('date')" format="DD.MM.YYYY" input-class="form-control rent-form__date" value-type="format" :disabled-date="minDateToday"></date-picker>
              <date-picker v-model="dateStartTime" @change="changeStartDateTime('time')" :disabled-time="minTimeToday" format="HH:mm" type="time" :time-picker-options="{start: '00:30', step:'00:30' , end: '23:30', format: 'HH:mm' }" input-class="form-control rent-form__time" value-type="format"></date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rent-form__part rent-form__part--small">
      <div class="rent-form__fields">
        <div class="rent-form__field-box">
          <label class="rent-form__field-label">Дата возврата</label>
          <div class="rent-form__field-group">
            <div class="rent-form__datetime">
              <date-picker v-model="dateEndField" @change="changeEndDateTime('date')" format="DD.MM.YYYY" input-class="form-control rent-form__date" value-type="format" :disabled-date="minDateEnd"></date-picker>
              <date-picker v-model="dateEndTime" @change="changeEndDateTime('time')" format="HH:mm" type="time" :time-picker-options="{start: '00:30', step:'00:30' , end: '23:30', format: 'HH:mm' }" input-class="form-control rent-form__time" value-type="format"></date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import RentFormLocationField from '@/components/RentForm/LocationField.vue';

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

export default {
    name: 'RentForm',
    components: {
      RentFormLocationField,
      DatePicker,
    },
    data() {
      return {
        dateStartField: moment(new Date(), 'DD.MM.YYYY').add(7, 'days').format('DD.MM.YYYY'),
        dateEndField: moment(new Date(), 'DD.MM.YYYY').add(10, 'days').format('DD.MM.YYYY'),
        dateEndTime: '12:00',
        dateStartTime: '12:00',
        endLocationOpened: false,
      };
    },
    computed: {
      isLoading() {
        return this.$store.getters.locationsLoading;
      },
      dateStart() {
        return this.$store.getters.dateStart;
      },
      dateEnd() {
        return this.$store.getters.dateEnd;
      },
      locationStart() {
        return this.$store.getters.locationStart;
      },
      locationEnd() {
        return this.$store.getters.locationEnd;
      },
      timeStart() {
        return this.$store.getters.timeStart;
      },
      timeEnd() {
        return this.$store.getters.timeEnd;
      },
      parameters() {
        return this.$store.getters.parameters;
      },
      cars() {
        return this.$store.getters.cars;
      },
      presets() {
        return this.$store.getters.presets;
      },
    },
    methods: {
      minDateToday(date) {
        let configDays = '';
        if (this.presets && this.presets.calendar) {
          configDays = this.presets.calendar.pick_up_datetime_offset_days-1;
        } else {
          configDays = 2;
        }
        return date < moment().add(configDays, 'days').toDate();
      },
      minTimeToday(date) {
        let configDays = '';
        if (this.presets && this.presets.calendar) {
          configDays = this.presets.calendar.pick_up_datetime_offset_days;
        } else {
          configDays = 3;
        }
        let day = moment().add(configDays,'days').format('DD.MM.YYYY');
        if (this.dateStart == day) {
          return date < new Date(moment(new Date(new Date()), 'DD.MM.YYYY').toDate());
        }
      },
      minDateEnd(date) {
        return date < new Date(moment(this.dateStart, 'DD.MM.YYYY').add(1, 'days').toDate());
      },
      changeStartDateTime(type) {
        let date = `${this.dateStartField} ${this.dateStartTime}`;

        let days = moment(date, 'DD.MM.YYYY HH:mm').diff(new Date(), 'hours');
        let configDays = '';
        if (this.presets && this.presets.calendar) {
          configDays = this.presets.calendar.pick_up_datetime_offset_days;
        } else {
          configDays = 3;
        }
        let configH = configDays*24;
        if (days < configH) {
          let h = configH - days;
          date = moment(date, 'DD.MM.YYYY HH:mm').add(h, 'hours').format('DD.MM.YYYY HH:mm');
        }
        this.$store.dispatch('changeStartDateTime', date).then(() => {
          this.$router.push({ query: Object.assign({}, this.$route.query, { pick_up_datetime: this.parameters.pick_up_datetime }) });
          if (type == 'time') {
            this.$store.dispatch('getCars');
          } else {
            let momentDateStart = moment(this.dateStart, 'DD.MM.YYYY');
            let momentDateEnd = moment(this.dateEnd, 'DD.MM.YYYY');
            if (momentDateStart >= momentDateEnd) {
              this.dateEndField = moment(this.dateStart, 'DD.MM.YYYY').add(7, 'days').format('DD.MM.YYYY');
              let date = `${this.dateEndField} ${this.dateEndTime}`;
              this.$store.dispatch('changeEndDateTime', date).then(() => {
                this.$router.push({ query: Object.assign({}, this.$route.query, { drop_off_datetime: this.parameters.drop_off_datetime }) });
                this.$store.dispatch('getCars');
              });
            } else {
              this.$store.dispatch('getCars');
            }
          }
        });
      },
      changeEndDateTime() {
        let date = `${this.dateEndField} ${this.dateEndTime}`;
        this.$store.dispatch('changeEndDateTime', date).then(() => {
          this.$router.push({ query: Object.assign({}, this.$route.query, { drop_off_datetime: this.parameters.drop_off_datetime }) });
          this.$store.dispatch('getCars');
        });
      },
    },
    mounted() {
      this.$store.dispatch('getCars');
    },
    watch: {
      dateStart(value) {
        this.dateStartField = value;
      },
      dateEnd(value) {
        this.dateEndField = value;
      },
      timeStart(value) {
        this.dateStartTime = value;
      },
      timeEnd(value) {
        this.dateEndTime = value;
      },
    },
}
</script>

<style>
  .rent-form {
    position: relative;
    z-index: 100;
  }
  .mx-datepicker {
    width: auto !important;
  }
  .mx-icon-calendar, .mx-icon-clear {
    left: -1px;
    color: #000;
    top: 16px;
    font-size: 20px;
    width: 20px;
  }
  @media screen and (min-width: 1000px) {
    .rent-form__date {
      background-image: none !important;
    }
  }
  .rent-form__time+i {
    display: none !important;
  }
  .rent-form__time+i+i {
    display: none !important;
  }
  .rent-form__field-box.disable {
    opacity: 0.5;
    position: relative;
  }
  .rent-form__field-box.disable:after {
    position: absolute;
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .autocomplete .mx-icon-clear {
    left: auto !important;
    background-color: #fed01f;
  }
  .autocomplete .mx-icon-clear svg {
    width: 23px;
  }
</style>